/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Reachability to SW1 LAN on R2</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1 mb-2">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion.ipRouteLan?'#28C76F':'transparent',border:'2px solid '+(r2Completion.ipRouteLan?'#28C76F':'#6b7280')}"></div>
                  <code class="text-base" :class="r2Completion.ipRouteLan?'text-success':''">ip route 192.168.0.0 255.255.255.0 e0/0 10.10.31.1</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">Verify — R3</span>
              <div class="space-y-1 ml-1 mt-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion.pingVerify?'#28C76F':'transparent',border:'2px solid '+(r3Completion.pingVerify?'#28C76F':'#6b7280')}"></div>
                  <code class="text-base" :class="r3Completion.pingVerify?'text-success':''">ping 192.168.0.1</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Default Route to Internet on R1</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r1Completion.ipDefaultRoute?'#28C76F':'transparent',border:'2px solid '+(r1Completion.ipDefaultRoute?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r1Completion.ipDefaultRoute?'text-success':''">ip route 0.0.0.0 0.0.0.0 e0/0 10.10.13.3</code>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Internet Subnet Route on R2 (Redundant)</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Progress }}/2</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion.ipRoute1?'#28C76F':'transparent',border:'2px solid '+(r2Completion.ipRoute1?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion.ipRoute1?'text-success':''">ip route 172.20.20.128 255.255.255.128 10.10.12.129</code>
              </div>
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion.ipRoute2?'#28C76F':'transparent',border:'2px solid '+(r2Completion.ipRoute2?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion.ipRoute2?'text-success':''">ip route 172.20.20.128 255.255.255.128 10.10.12.1</code>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">Primary + Floating Route on R1 → SW1</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/2</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r1Completion.ipRoutePrimary?'#28C76F':'transparent',border:'2px solid '+(r1Completion.ipRoutePrimary?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r1Completion.ipRoutePrimary?'text-success':''">ip route 192.168.0.0 255.255.255.0 10.10.12.2</code>
              </div>
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r1Completion.ipRouteBackup?'#28C76F':'transparent',border:'2px solid '+(r1Completion.ipRouteBackup?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r1Completion.ipRouteBackup?'text-success':''">ip route 192.168.0.0 255.255.255.0 10.10.12.130 2</code>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,r2Completion.saved,r3Completion.saved].filter(Boolean).length }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2','r3']" :key="'s-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'" key="r3" id="r3_terminal" :commands="r3Commands" :prompt="r3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

const mkCommands = (rk, vm) => ({
  help:      () => createStdout(HELP),
  enable:    () => createStdout(''),
  configure: (x) => vm.iosConfigure(rk, x),
  conf:      (x) => vm.iosConfigure(rk, x),
  exit:      () => vm.iosExit(rk),
  end:       () => vm.iosEnd(rk),
  ip:        (x) => vm.iosIp(rk, x),
  ping:      (x) => vm.iosPing(rk, x),
  copy:      (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_Routing_Configuration_4.png',
      sel: 'r2',
      totalScore: 0,

      r1: { mode: 'exec' },
      r2: { mode: 'exec' },
      r3: { mode: 'exec' },

      r1Completion: { ipDefaultRoute: false, ipRoutePrimary: false, ipRouteBackup: false, saved: false },
      r2Completion: { ipRouteLan: false, ipRoute1: false, ipRoute2: false, saved: false },
      r3Completion: { pingVerify: false, saved: false },

      r1Commands: null,
      r2Commands: null,
      r3Commands: null,
    };
  },

  computed: {
    r1Prompt() { return this.r1.mode === 'config' ? 'R1(config)#' : 'R1#'; },
    r2Prompt() { return this.r2.mode === 'config' ? 'R2(config)#' : 'R2#'; },
    r3Prompt() { return this.r3.mode === 'config' ? 'R3(config)#' : 'R3#'; },
    task1Progress() { return (this.r2Completion.ipRouteLan ? 1 : 0) + (this.r3Completion.pingVerify ? 1 : 0); },
    task1Done()     { return !!this.r3Completion.pingVerify; },
    task2Done()     { return !!this.r1Completion.ipDefaultRoute; },
    task3Progress() { return (this.r2Completion.ipRoute1 ? 1 : 0) + (this.r2Completion.ipRoute2 ? 1 : 0); },
    task3Done()     { return this.r2Completion.ipRoute1 && this.r2Completion.ipRoute2; },
    task4Progress() { return (this.r1Completion.ipRoutePrimary ? 1 : 0) + (this.r1Completion.ipRouteBackup ? 1 : 0); },
    task4Done()     { return this.r1Completion.ipRoutePrimary && this.r1Completion.ipRouteBackup; },
    saveDone()      { return this.r1Completion.saved && this.r2Completion.saved && this.r3Completion.saved; },
  },

  watch: {
    'r2Completion.ipRouteLan'(val)  { if (val) this.switchTo('r3'); },
    'r3Completion.pingVerify'(val)  { if (val) this.switchTo('r1'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
    this.r3Commands = mkCommands('r3', this);
  },

  methods: {
    getCompletion(k) { return this[k + 'Completion']; },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },
    switchTo(r) {
      this.sel = r;
      this.$nextTick(() => {
        const el = document.querySelector(`#${r}_terminal input, #${r}_terminal textarea`);
        if (el) el.focus();
      });
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') return createStderr('% Must be in configuration mode — type "configure terminal" first');
      if (needed === 'exec')   return createStderr('% Must be in privileged EXEC mode — type "end" first');
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r3Completion].forEach(c => Object.values(c).forEach(v => { if (v) score++; }));
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 10) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosConfigure(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      if (this[rk].mode === 'config') this[rk].mode = 'exec';
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosIp(rk, x) {
      const s = this[rk]; const c = this[rk + 'Completion'];
      if (x._[1] !== 'route') return createStderr('% Invalid input detected');
      const me = this.modeErr(s, 'config'); if (me) return me;
      const network = x._[2];

      // Task 1 — R2 static route to SW1 LAN (interface + next-hop form)
      if (rk === 'r2' && network === '192.168.0.0' && !c.ipRouteLan) {
        c.ipRouteLan = true; this.updateScore();
        return createStdout(this.guide(
          'Static route to SW1\'s LAN (192.168.0.0/24) added on R2 using both a connected exit interface (e0/0) and an explicit next-hop (10.10.31.1), as required by company policy. ' +
          'On multi-access Ethernet segments, specifying the exit interface alone triggers proxy-ARP and the router resolves a separate ARP entry for every destination — adding the next-hop IP pins resolution to a single ARP entry for 10.10.31.1 (R3\'s interface on the R2–R3 link). ' +
          '→ Switch to R3: type "end" then "ping 192.168.0.1" to verify reachability to the SW1 gateway.'
        ));
      }

      // Task 2 — R1 IPv4 default route toward Internet via R3 (interface + next-hop form)
      if (rk === 'r1' && network === '0.0.0.0' && !c.ipDefaultRoute) {
        c.ipDefaultRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Default route (gateway of last resort) configured on R1 via exit interface e0/0 and next-hop 10.10.13.3 (R3\'s interface on the R1–R3 link). ' +
          '0.0.0.0/0 matches any destination with no more specific route — all unknown traffic will exit toward R3 and onward to the Internet. ' +
          'The company policy of specifying both interface and next-hop prevents proxy-ARP overhead on Ethernet. ' +
          '→ Configure Task 3 on R2: the redundant static routes to the Internet subnet.'
        ));
      }

      // Task 3 — R2 first internet subnet route (via 10.10.12.129)
      if (rk === 'r2' && network === '172.20.20.128' && x._[4] === '10.10.12.129' && !c.ipRoute1) {
        c.ipRoute1 = true; this.updateScore();
        return createStdout(this.guide(
          'First static route to the Internet subnet (172.20.20.128/25) via next-hop 10.10.12.129 — one of the two redundant links between R2 and R1. ' +
          'When two static routes share the same destination prefix and the same administrative distance (default AD 1), IOS installs both simultaneously and load-balances traffic across them using Equal-Cost Multi-Path (ECMP). ' +
          '→ Add the second route via the other link to complete the redundancy.'
        ));
      }

      // Task 3 — R2 second internet subnet route (via 10.10.12.1)
      if (rk === 'r2' && network === '172.20.20.128' && x._[4] === '10.10.12.1' && !c.ipRoute2) {
        c.ipRoute2 = true; this.updateScore();
        return createStdout(this.guide(
          'Second static route to 172.20.20.128/25 via next-hop 10.10.12.1 — the other redundant R2–R1 link. ' +
          'Both routes now appear in the routing table simultaneously. IOS performs ECMP load-balancing across them, fully utilizing both physical links. ' +
          'The task description says "single static route" because it\'s one logical destination prefix — but two physical next-hops are needed to cover both links. ' +
          '→ Switch to R1 and configure Task 4: the primary and floating backup routes toward SW1.'
        ));
      }

      // Task 4 — R1 primary route to SW1 LAN via Ethernet0/1
      if (rk === 'r1' && network === '192.168.0.0' && x._[4] === '10.10.12.2' && !c.ipRoutePrimary) {
        c.ipRoutePrimary = true; this.updateScore();
        return createStdout(this.guide(
          'Primary route to SW1\'s LAN (192.168.0.0/24) via next-hop 10.10.12.2 through Ethernet0/1. ' +
          'No administrative distance specified = default static route AD of 1, which is lower than any dynamic routing protocol. ' +
          'This route will be installed in the routing table and preferred as long as Ethernet0/1 is up. ' +
          '→ Add the floating backup route via Ethernet0/2 with AD 2.'
        ));
      }

      // Task 4 — R1 floating backup route via Ethernet0/2 (AD 2)
      if (rk === 'r1' && network === '192.168.0.0' && x._[4] === '10.10.12.130' && !c.ipRouteBackup) {
        c.ipRouteBackup = true; this.updateScore();
        return createStdout(this.guide(
          'Floating static route via next-hop 10.10.12.130 (Ethernet0/2) with administrative distance 2. ' +
          'Because AD 2 > AD 1 (primary), this route is NOT installed in the routing table while the primary link is active — it "floats" in the config, invisible to the forwarding engine. ' +
          'If Ethernet0/1 fails and the primary route is withdrawn, AD 2 becomes the best available route and the backup instantly activates. ' +
          'This provides automatic failover without any dynamic routing protocol. → Save all three routers with "end" then "copy running-config startup-config".'
        ));
      }

      return createStdout('');
    },

    iosPing(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      const c = this[rk + 'Completion'];

      const successOut =
        'Type escape sequence to abort.<br>' +
        'Sending 5, 100-byte ICMP Echos to 192.168.0.1, timeout is 2 seconds:<br>' +
        '.!!!!<br>' +
        'Success rate is 80 percent (4/5), round-trip min/avg/max = 1/2/4 ms';

      if (rk === 'r3') {
        if (!this.r2Completion.ipRouteLan) {
          return createStdout(
            'Type escape sequence to abort.<br>' +
            'Sending 5, 100-byte ICMP Echos to 192.168.0.1, timeout is 2 seconds:<br>' +
            '.....<br>' +
            'Success rate is 0 percent (0/5)'
          );
        }
        if (!c.pingVerify) {
          c.pingVerify = true; this.updateScore();
          return createStdout(successOut + this.guide(
            'Ping succeeded — ".!!!!" is expected. The leading "." is ARP resolution for the first hop; the four "!" are successful ICMP echo replies. ' +
            '80% (4/5) confirms R3 can reach 192.168.0.1 (SW1\'s default gateway) via R2\'s new route. ' +
            'No return route was needed on R1 because a default route to the Internet pre-exists, covering the return path from R1 back toward R3. ' +
            '→ Switch to R1 and configure the default route for Task 2.'
          ));
        }
        return createStdout(successOut);
      }

      return createStdout(successOut);
    },

    iosCopy(rk, x) {
      const me = this.modeErr(this[rk], 'exec'); if (me) return me;
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        const remaining = [this.r1Completion.saved, this.r2Completion.saved, this.r3Completion.saved].filter(Boolean).length;
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Destination filename [startup-config]? <br>Building configuration...<br>[OK]' +
          this.guide(
            `${rk.toUpperCase()} configuration saved to NVRAM. On reboot, the router will load this exact configuration. ` +
            (this.saveDone ? '✓ All devices saved — simulation complete!' : `→ Save the remaining router${remaining < 2 ? '' : 's'}.`)
          )
        );
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

